import React from 'react'
import withStyles from 'react-jss'

import { StateConsumer } from '../state'
import { ControlConsumer } from '../control'
import { shouldShowSkipIntro } from './utils/should-show-skip-intro'
import { getSkipIntroEndTime } from './utils/get-skip-intro-end-time'
import Button from '../../button'

const styles = theme => {
  return {
    wrapper: {
      bottom: 85,
      left: 0,
      marginLeft: 25,
      padding: [10, 20],
      position: 'absolute',
      flexDirection: 'column',
      cursor: 'pointer',
      zIndex: theme.zIndex.overlay,
      maxWidth: 141
    }
  }
}

class SkipIntro extends React.PureComponent {
  render() {
    const { classes } = this.props

    return (
      <StateConsumer>
        {({
          isPlayingAd,
          currentTime,
          getMetaData,
          getSetters,
          isUiHidden,
          isInitialLoadingDone,
          isAdOnPauseShown,
          isEpisodeSelectorOpen
        }) => {
          // render nothing
          // when initial loading is not done or ad is playing or AoP is showing or episode selector opens
          if (!isInitialLoadingDone || isPlayingAd || isAdOnPauseShown || isEpisodeSelectorOpen) return null

          const shouldRenderSkipIntro = shouldShowSkipIntro(
            getMetaData,
            currentTime,
            isUiHidden
          )

          if (!shouldRenderSkipIntro) return null

          return (
            <ControlConsumer>
              {({ seekTo }) => {
                const { setCurrentTime } = getSetters()
                const skipIntroEndTime = getSkipIntroEndTime(getMetaData)

                return (
                  <Button
                    className={classes.wrapper}
                    onClick={() => {
                      seekTo(skipIntroEndTime)
                      setCurrentTime(skipIntroEndTime)
                    }}
                    text="SKIP INTRO"
                  />
                )
              }}
            </ControlConsumer>
          )
        }}
      </StateConsumer>
    )
  }
}

export default withStyles(styles)(SkipIntro)
